import { ConsultationsContainer } from '../containers/ConsultationsContainer/index'

export const ConsultationsPage = ({type, setType}) => (
    <ConsultationsContainer type={type} setType={setType}/>
)